export const CONTRACT_ADDRESS = '0x08A8fDBddc160A7d5b957256b903dCAb1aE512C5';
export const BATCH_SIZE = 1000;

/**
 * tokenBalances(address[],address)
 */
export const TOKEN_BALANCES_ID = 'aad33091';
export const TOKEN_BALANCES_TYPE: ['address[]', 'address'] = ['address[]', 'address'];

/**
 * etherBalances(address[])
 */
export const ETHER_BALANCES_ID = 'dbdbb51b';
export const ETHER_BALANCES_TYPE: ['address[]'] = ['address[]'];

/**
 * tokensBalance(address,address[])
 */
export const TOKENS_BALANCE_ID = 'e5da1b68';
export const TOKENS_BALANCE_TYPE: ['address', 'address[]'] = ['address', 'address[]'];

/**
 * balanceOf(address)
 */
export const BALANCE_OF_ID = '70a08231';
export const BALANCE_OF_TYPE: ['address'] = ['address'];
